import React, { useState, useEffect, useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import Papa from 'papaparse';
import { useDropzone } from 'react-dropzone';
import { createRestaurant } from '../../store/actions/restaurantActions'

function createUrl(location, locationList, setHttpResponse){
    console.log('location');
    console.log(location);

    for(var locs in locationList){
      if(JSON.stringify(locationList[locs][1]) === JSON.stringify(location)){
        console.log('conflict');
        location = [location[0] + 0.00001, location[1]];
      }
    }

    var fullUrl ='';
    locationList.map(location=>
      fullUrl = fullUrl.concat(location[1].toString()+';')
    )
    fullUrl = fullUrl.slice(0,-1);
    calculateDistanceMatrix(location, locationList, setHttpResponse);
  }

function calculateDistanceMatrix(location1, locationList, setHttpResponse){
    const Http = new XMLHttpRequest();
    
    const url = 'https://dev.virtualearth.net/REST/v1/Routes/DistanceMatrix?origins='+location1[0]+','+location1[1]+'&destinations='+locationList+'&travelMode=walking&distanceUnit=mi&key=AkkmVqZTTAl0pdIReyon_6fwQ9WkzPuTxhYYqAAjV08oE2_jX_OqCj1Dbytnlh_O'

    Http.open("GET", url);
    Http.send();

    Http.onreadystatechange=function(){
      if(this.readyState === 4 && this.status === 200){
        var parsedJSON = JSON.parse(Http.responseText);
        setHttpResponse(parsedJSON);
      }
    }   
  }


function handleSubmit(project, dispatch){
    let test = {...project};
    console.log('test');
    console.log(test);
    dispatch(createRestaurant(project));
  }


function FromCSV({ contents }) {
  const restaurants = useSelector((state)=>state.firestore.data.restaurants);
  const dispatch = useDispatch();
  const userLocation = [37.545974,-77.455454];

  const onDrop = useCallback(acceptedFiles => {
    if (acceptedFiles.length) {
      parseFile(acceptedFiles[0]);
    }
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop
  });
  const [parsedCsvData, setParsedCsvData] = useState([]);
  const [choice, setChoice] = useState(0);
  const [httpResponse, setHttpResponse] = useState('');
  const [locationList, setLocationList] = useState([]);

  const parseFile = file => {
    Papa.parse(file, {
      header: true,
      complete: results => {
        setParsedCsvData(results.data)
      },
    });
  };

  useEffect(()=>{
   if(httpResponse !== ''){
        //get array of distances from httpresponse
        const results = httpResponse.resourceSets[0].resources[0].results.map((result)=>{return(result.travelDistance)});
        var riffle = [];
        for (var i = 0; i < locationList.length; i ++){
          riffle.push([locationList[i][0],results[i]]);
        }
        console.log(results);
      } 
    },[httpResponse])

  useEffect(()=>{
    if(parsedCsvData[choice]!==undefined){
      createUrl(userLocation,[[parsedCsvData[choice]['Latitude'], parsedCsvData[choice]['Longitude']]],setHttpResponse)
    }
  },[choice])

  useEffect(()=>{
    console.log(parsedCsvData);
    submitRests(choice);
  },[parsedCsvData, choice])

  const [newResta, setNewResta] = useState(false);

  function submitRests(number){
    if(parsedCsvData[number]){
    let newRest = {};

    newRest['orderUrl'] = '';
    newRest['menuUrl'] = '';
    newRest['zip'] = '';
    newRest['tags'] = '';

    newRest['name'] = parsedCsvData[number]['name'];
    newRest['url'] = parsedCsvData[number]['url'];

    if(newRest['url'] !== ""){
      if(newRest['url'].slice(0,8) === 'https://'){
        newRest['url'] = newRest['url'].slice(8);
      }
      if(newRest['url'].slice(0,7) === 'http://'){
        newRest['url'] = newRest['url'].slice(7);
      }
    }


    newRest['phoneNumber'] = parsedCsvData[number]['phoneNumber'];
    let add = parsedCsvData[number]['address'].split(',');
    newRest['address'] = add[0];
    newRest['city'] = add[1];
    newRest['state'] = 'VA';
    newRest['content'] = '';

    let test = parsedCsvData[number]['Mon'].split(' ');
    let defaultHours = ['0','','AM','-','','PM'];
    if(parsedCsvData[number]['Mon']!== ''){
      let test = parsedCsvData[number]['Mon'].split(' ');
      newRest['mondayAM'] = test[1];
      newRest['monAM'] = test[2];
      newRest['mondayPM'] = test[4];
      newRest['monPM'] = test[5];
    }
    else{
      newRest['mondayAM'] = defaultHours[1];
      newRest['monAM'] = defaultHours[2];
      newRest['mondayPM'] = defaultHours[4];
      newRest['monPM'] = defaultHours[5]; 
    }

    if(parsedCsvData[number]['Tues']!== ''){
      let test = parsedCsvData[number]['Tues'].split(' ');
      newRest['tuesdayAM'] = test[1];
      newRest['tueAM'] = test[2];
      newRest['tuesdayPM'] = test[4];
      newRest['tuePM'] = test[5];
    }
    else{
      newRest['tuesdayAM'] = defaultHours[1];
      newRest['tueAM'] = defaultHours[2];
      newRest['tuesdayPM'] = defaultHours[4];
      newRest['tuePM'] = defaultHours[5]; 
    }

    if(parsedCsvData[number]['Wed']!== ''){
      let test = parsedCsvData[number]['Wed'].split(' ');
      newRest['wednesdayAM'] = test[1];
      newRest['wedAM'] = test[2];
      newRest['wednesdayPM'] = test[4];
      newRest['wedPM'] = test[5];
    }
    else{
      newRest['wednesdayAM'] = defaultHours[1];
      newRest['wedAM'] = defaultHours[2];
      newRest['wednesdayPM'] = defaultHours[4];
      newRest['wedPM'] = defaultHours[5]; 
    }

    if(parsedCsvData[number]['Thurs']!== ''){
      let test = parsedCsvData[number]['Thurs'].split(' ');
      newRest['thursdayAM'] = test[1];
      newRest['thuAM'] = test[2];
      newRest['thursdayPM'] = test[4];
      newRest['thuPM'] = test[5];
    }
    else{
      newRest['thursdayAM'] = defaultHours[1];
      newRest['thuAM'] = defaultHours[2];
      newRest['thursdayPM'] = defaultHours[4];
      newRest['thuPM'] = defaultHours[5]; 
    }

    if(parsedCsvData[number]['Fri']!== ''){
      let test = parsedCsvData[number]['Fri'].split(' ');
      newRest['fridayAM'] = test[1];
      newRest['friAM'] = test[2];
      newRest['fridayPM'] = test[4];
      newRest['friPM'] = test[5];
    }
    else{
      newRest['fridayAM'] = defaultHours[1];
      newRest['friAM'] = defaultHours[2];
      newRest['fridayPM'] = defaultHours[4];
      newRest['friPM'] = defaultHours[5]; 
    }

    if(parsedCsvData[number]['Sat']!== ''){
      let test = parsedCsvData[number]['Sat'].split(' ');
      newRest['saturdayAM'] = test[1];
      newRest['satAM'] = test[2];
      newRest['saturdayPM'] = test[4];
      newRest['satPM'] = test[5];
    }
    else{
      newRest['saturdayAM'] = defaultHours[1];
      newRest['satAM'] = defaultHours[2];
      newRest['saturdayPM'] = defaultHours[4];
      newRest['satPM'] = defaultHours[5]; 
    }

    if(parsedCsvData[number]['Sun']!== ''){
      let test = parsedCsvData[number]['Sun'].split(' ');
      newRest['sundayAM'] = test[1];
      newRest['sunAM'] = test[2];
      newRest['sundayPM'] = test[4];
      newRest['sunPM'] = test[5];
    }
    else{
      newRest['sundayAM'] = defaultHours[1];
      newRest['sunAM'] = defaultHours[2];
      newRest['sundayPM'] = defaultHours[4];
      newRest['sunPM'] = defaultHours[5]; 
    }

    newRest['hours'] = [
    newRest['sundayAM'] + ' ' + newRest['sunAM'] + ' - ' + newRest['sundayPM'] + ' ' + newRest['sunPM'], 
    newRest['mondayAM'] + ' ' + newRest['monAM'] + ' - ' + newRest['mondayPM'] + ' ' + newRest['monPM'],
    newRest['tuesdayAM'] + ' ' + newRest['tueAM'] + ' - ' + newRest['tuesdayPM'] + ' ' + newRest['tuePM'],
    newRest['wednesdayAM'] + ' ' + newRest['wedAM'] + ' - ' + newRest['wednesdayPM'] + ' ' + newRest['wedPM'],
    newRest['thursdayAM'] + ' ' + newRest['thuAM'] + ' - ' + newRest['thursdayPM'] + ' ' + newRest['thuPM'],
    newRest['fridayAM'] + ' ' + newRest['friAM'] + ' - ' + newRest['fridayPM'] + ' ' + newRest['friPM'],
    newRest['saturdayAM'] + ' ' + newRest['satAM'] + ' - ' + newRest['saturdayPM'] + ' ' + newRest['satPM']
    ]

    newRest['location'] = [parsedCsvData[number]['Latitude'], parsedCsvData[number]['Longitude']]; 


    console.log('newRest');
    console.log(newRest);
    console.log(parsedCsvData[number]['Distance']);

    if(JSON.stringify(newRest) !== JSON.stringify(newResta)){
      setNewResta(newRest);  
    }  
  }

  }

  return (
    <>
      <div {...getRootProps()}>
        <input {...getInputProps()} />
        <p>Drag 'n' drop some files here, or click to select files</p>
      </div>
      <div className="input-field">
        <label htmlFor="quantity">Choice</label>
        <input className="active" type="number" id="quantity1" name="quantity" min="0" max="1500" value={choice} onChange={event => setChoice(event.target.value)} onKeyDown = {()=>{if (event.keyCode == 13){handleSubmit(newResta, dispatch)}}}   />
      </div>
      <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
        <button key='sub' className="btn pink lighten-1" onClick={()=>{handleSubmit(newResta, dispatch)}}>Submit</button>
      </div>
    </>
  );
}

export default FromCSV;